const trimSku = (value: unknown): string => String(value ?? '').trim();

/** True when local row should still accept remote SKU despite newer local updated_at. */
export function shouldApplyRemoteProductDespiteLocalNewer(args: {
  localUpdated: string | null;
  remoteUpdated: string;
  localSku: string | null;
  remoteSku: string | null;
}): boolean {
  const { localUpdated, remoteUpdated, localSku, remoteSku } = args;
  if (!trimSku(localSku) && trimSku(remoteSku)) {
    if (!localUpdated || !remoteUpdated) return true;
    const lm = Date.parse(localUpdated);
    const rm = Date.parse(remoteUpdated);
    if (Number.isNaN(lm) || Number.isNaN(rm)) return true;
    if (lm > rm) return true;
  }
  return false;
}

/** Clear local barcode that came from old RPC coalesce(barcode, sku) when server has no barcode. */
export function shouldClearPhantomBarcode(args: {
  serverBarcode: string | null | undefined;
  localBarcode: string | null | undefined;
  localSku: string | null | undefined;
}): boolean {
  if (trimSku(args.serverBarcode)) return false;
  const localBarcode = trimSku(args.localBarcode);
  const localSku = trimSku(args.localSku);
  return localBarcode !== '' && localBarcode.toUpperCase() === localSku.toUpperCase();
}

export { trimSku as trimProductSku };
